import { inject, Injector, provideEnvironmentInitializer } from '@angular/core';
import { SOFTLINE_CONFIG_OFFLINE_FEATURE } from '@softline/application';
import { SOFTLINE_CONFIG_INDEXED_DB, Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { PdfEditorToolGroupName } from '@softapps/core/pdf';
import {
  SOFTLINE_CONFIG_PDF_EDITOR,
  SOFTLINE_DB_PDF_EDITOR,
  SOFTLINE_FEATURE_PDF_EDITOR,
} from '@softapps/core/pdf';
import { PdfEditorStore } from '@softapps/core/pdf';

export const pdfEditorProviders = [
  {
    provide: SOFTLINE_CONFIG_OFFLINE_FEATURE,
    useValue: { featureName: SOFTLINE_FEATURE_PDF_EDITOR, fields: ['files'] },
    multi: true,
  },
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.registerFeature(
      SOFTLINE_FEATURE_PDF_EDITOR,
      PdfEditorStore.feature,
      inject(Injector)
    );
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'pdfEditor',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'pdfEditor',
      language: 'en',
      translations: en,
    });
  }),
  {
    provide: SOFTLINE_CONFIG_INDEXED_DB,
    useValue: {
      name: SOFTLINE_DB_PDF_EDITOR,
      version: 1,
      objectStoreConfigs: [
        {
          name: 'customTools',
          parameters: { keyPath: 'groupName', autoIncrement: false },
          schema: [],
        },
      ],
    },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_PDF_EDITOR,
    useValue: {
      key: 'tools',
      value: {
        [PdfEditorToolGroupName.Stamp]: [
          /*{
            id: uuid(),
            type: PdfEditorToolType.Image,
            url: '/assets/stamps/stamp-3.png',
          },
          {
            id: uuid(),
            type: PdfEditorToolType.Image,
            url: '/assets/stamps/stamp-4.png',
          },*/
        ],
      },
    },
    multi: true,
  },
];
